import React from 'react';

export default function WolfTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="26.06,32.35 11.95,32.35 8.95,20.87 23.06,20.87" fill="#B2AFBE" />
      <polygon points="11.95,32.35 26.06,32.35 24.06,38.0 9.95,38.0" fill="#7B7690" opacity="0.95" />
      <polygon points="11.95,32.35 9.95,38.0 6.96,26.53 8.95,20.87" fill="#7B7690" opacity="0.95" />
      <polygon points="34.89,17.3 16.08,17.3 12.09,2.0 30.9,2.0" fill="#B2AFBE" />
      <polygon points="16.08,17.3 34.89,17.3 27.91,37.09 9.1,37.09" fill="#7B7690" opacity="0.95" />
      <polygon points="16.08,17.3 9.1,37.09 5.11,21.79 12.09,2.0" fill="#7B7690" opacity="0.95" />
      <polygon points="27.57,31.94 13.47,31.94 18.2,18.51 32.31,18.51" fill="#B2AFBE" />
      <polygon points="15.21,7.04 29.32,7.04 32.31,18.51 18.2,18.51" fill="#E8E7EB" opacity="0.92" />
      <polygon points="13.47,31.94 10.47,20.47 15.21,7.04 18.2,18.51" fill="#7B7690" opacity="0.95" />
      <polygon points="27.57,31.94 13.47,31.94 18.2,18.51 32.31,18.51" fill="#B2AFBE" />
      <polygon points="15.21,7.04 29.32,7.04 32.31,18.51 18.2,18.51" fill="#E8E7EB" opacity="0.92" />
      <polygon points="13.47,31.94 10.47,20.47 15.21,7.04 18.2,18.51" fill="#7B7690" opacity="0.95" />
    </svg>
  );
}
